var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[(_vm.video_url)?_c('video',{staticClass:"myVido",attrs:{"id":"video1","controls":"true","controlslist":"nodownload","autoplay":"autoplay"}},[_c('source',{attrs:{"src":_vm.video_url,"type":"video/mp4"}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }